import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import 'element-plus/dist/index.css'
//import '@/assets/base.css'
import i18n from './i18n'
;(async () => {
  // ✅ 在应用初始化时恢复数据
await store.dispatch('user/restore');
const app = createApp(App)
app.use(router)
app.use(store)
app.use(i18n)
// 根据本地存储或默认设置语言
const locale = localStorage.getItem('lang') || 'en'
app.use(ElementPlus, {
  locale: locale === 'zh-CN' ? zhCn : en
})
//app.use(ElementPlus)

// // 在应用创建前就监听 beforeunload 事件
// window.addEventListener('beforeunload', (event) => {
//   const token = sessionStorage.getItem("authToken");
//   if (token) {
//     // 使用 sendBeacon 发送注销请求
//     const logoutData = new FormData();
//     logoutData.append('token', token);
//     navigator.sendBeacon('/api/User/logout', logoutData);
    
//     // 清理本地存储
//     sessionStorage.removeItem("authToken");
//     localStorage.removeItem("userInfo");
//   }
  
//   event.preventDefault();
//   event.returnValue = "您确定要离开吗？系统将自动注销您的登录状态。";
// });


app.mount('#app')
})()


 

